import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Figure from 'react-bootstrap/Figure';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { Trash } from 'react-bootstrap-icons';

function ProductImages(props) {
  const [ showAddImage, setShowAddImage ] = useState(false);
  const [ newImage, setNewImage ] = useState({imageShows: null, heroImage: false});
  const [ file, setFile ] = useState();
  const [ imageDeleted, setImageDeleted ] = useState(false);
  const { productImages, imageUploading, readOnly, onUpload, onDelete } = props;
  const imageShowsEnum = ['','product-front','product-three-quarter-right','product-right-side'];
  const toggleAddImage = () => {
    setShowAddImage(!showAddImage);
  };
  const handleAddImageChange = (e) => {
    const { id, value, checked } = e.target;
    setNewImage({...newImage, [id]: (typeof checked === 'undefined') ? value : checked});
  }
  const handleFileUpload = e => {
    setFile(e.target.files[0]);
  };
  const uploadNewImage = () => {
    onUpload({ file, ...newImage }, () => {setFile(); setNewImage({ imageShows: null, heroImage: false }); setShowAddImage(false);});
  }

  return (
    <Container>
      <Row>
        {productImages?.length > 0 ? (
          productImages?.map((productImage, index) => (
            <Col key={productImage.url} xs={12} sm={6} md={6} lg={4}>
              <Figure className="mx-0 p-1 border">
                <Figure.Image
                  className="border"
                  alt="product image"
                  src={productImage.url}
                />
                <Figure.Caption className="text-center">
                  {productImage.imageShows}
                  {productImage.heroImage && <strong> (HERO IMG)</strong>}
                  {readOnly !== true && onDelete && (
                    <Button
                      variant="primary"
                      className="float-right"
                      onClick={() => {
                        setImageDeleted(true);
                        onDelete(index);
                      }}
                    >
                      <Trash />
                    </Button>
                  )}
                </Figure.Caption>
              </Figure>
            </Col>
          ))
        ) : (
          <Col>No Product Images</Col>
        )}
      </Row>
      <Row>
        <Col xs={12}>
          {showAddImage && (
            <Card className="mb-4">
              <Card.Body>
                <Card.Title>Add Product Image</Card.Title>
                <Form>
                  <Row>
                    <Col sm={12} md={5} lg={4}>
                      <Form.Group>
                        <Form.File
                          disabled={imageUploading}
                          id="upload-product-image"
                          onChange={handleFileUpload}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={5} lg={3}>
                      <Form.Control
                        as="select"
                        disabled={imageUploading}
                        id="imageShows"
                        onChange={handleAddImageChange}
                      >
                        {imageShowsEnum?.map((imageShowsOption) => (
                          <option
                            key={imageShowsOption}
                            value={imageShowsOption}
                          >
                            {imageShowsOption}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                    <Col md={1} lg={1}>
                      <Form.Group>
                        <Form.Check
                          disabled={imageUploading}
                          type="checkbox"
                          label="Hero"
                          id="heroImage"
                          onChange={handleAddImageChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} lg={4} className="text-center my-xs-2 mt-lg-0">
                      <Button
                        variant={imageUploading ? 'secondary' : 'primary'}
                        onClick={uploadNewImage}
                      >
                        {imageUploading
                          ? 'Uploading...'
                          : 'Upload New Product Image'}
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <small>
                        (NOTE: Pressing "Upload New Product Image" will upload
                        and overwrite images with same name, but will NOT update
                        product metadata until "Save Metadata" is pressed.)
                      </small>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          )}
          {readOnly === false && showAddImage === false && (
            <div className="text-center">
              <Button variant="primary" onClick={toggleAddImage}>
                Add Product Image
              </Button>
            </div>
          )}
        </Col>
      </Row>
      {imageDeleted && (
        <Row>
          <Col className="mt-3">
            <small>
              (NOTE: Deleting image will NOT update product metadata until "Save
              Metadata" is pressed, AND the image file itself is not deleted,
              just the entry in product metadata.)
            </small>
          </Col>
        </Row>
      )}
    </Container>
  );
}

export default ProductImages;